import React from "react";
import { useLocation } from "react-router-dom";
import { Env } from "core/utils";
import { Loading } from "core/components";
import Cookies from "js-cookie";
import { StatusHelper } from "@jawbreaker/auth-login-callback";
import { Status } from "@jawbreaker/auth-status";
import { stateVar } from "common/Auth/Utils/state";
export var prepRouter = function (matcher, Nav, setNavConfig, ErrorPage) {
    return function (_a) {
        var appState = _a.appState;
        /**
         * Render error on SSR.
         * Error was probably set by a data fetching render
         * @NOTE we are using hooks after this condition.
         * So we are using conditional hooks. This is not OK.
         * But we are only ever doing that on the server so it is OK.
         */
        if (appState.pageError !== null) {
            if (Env.isServer) {
                return (React.createElement(Nav, null,
                    React.createElement(ErrorPage, { error: appState.pageError })));
            }
        }
        var pathname = useLocation().pathname;
        var route = matcher(pathname);
        if (!Env.isServer) {
            var statusHelper = new StatusHelper(undefined);
            var authState = statusHelper.parse(Cookies.get("vtmAuthState"));
            if (!authState.isValid) {
                document.cookie = "vtmAuthState=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.vtm.be;";
                document.cookie = "isPlusUser=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.vtm.be;";
                stateVar(Status.loggedOut(authState.reason, false));
            }
            if (authState.isValid && !Status.isLoggedOut(authState.payload) && statusHelper.isExpired(authState.payload.data)) {
                var currentOrigin = window.location.origin;
                document.cookie = "currentUrl=".concat((window.location.href), "; path=/; domain=vtm.be; secure; SameSite=Lax");
                window.location.href = "https://account.vtm.be/login?callback_url=".concat(currentOrigin, "/login-callback");
            }
        }
        /**
         * If there is a NavConfig set on the route,
         * it always has priority.
         */
        if (route.kind !== "FallbackRoute") {
            setNavConfig(route.navConfig);
        }
        return (React.createElement(Nav, null,
            React.createElement(route.Provider, { appState: appState, slug: pathname, setNavConfig: setNavConfig, Loading: Loading, Error: ErrorPage })));
    };
};
